export const EDIT_BUSINESS = "EDIT_BUSINESS"
export const EDIT_BUSINESS_SUCCESS = "EDIT_BUSINESS_SUCCESS"
export const EDIT_BUSINESS_CLEAN = "EDIT_USER_CLEAN"
export const API_ERROR = "API_ERROR"
